import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { UnderConstructionComponent } from './components/pages/under-construction/under-construction.component';
import { PhotoComponent } from './components/pages/photo/photo.component';
import { DetailsComponent } from './details/details.component';
import { NoticeComponent } from './components/pages/notice/notice.component';
import { TemplatePageComponent } from './template-page/template-page.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { VideoGalleryComponent } from './components/pages/video-gallery/video-gallery.component';
import { VideoFolderComponent } from './components/pages/video-folder/video-folder.component';
import { AdministrationComponent } from './components/pages/administration/administration.component';
import { ImageGalleryComponent } from './components/pages/image-gallery/image-gallery.component';
import { ImageFolderComponent } from './components/pages/image-folder/image-folder.component';
import { TeachersComponent } from './components/pages/teachers/teachers.component';
import { EmployesComponent } from './components/pages/employes/employes.component';
import { PrincipalComponent } from './components/pages/principal/principal.component';
import { NotFoundComponent } from "./components/pages/not-found/not-found.component";
import { ChairmanComponent } from './components/pages/chairman/chairman.component';
import { SchoolTeacherComponent } from './components/pages/school-teacher/school-teacher.component';
import { CollegeTeacherComponent } from './components/pages/college-teacher/college-teacher.component';
import { AchievementComponent } from './components/pages/achievement/achievement.component';
import { NewsComponent } from './components/pages/news/news.component';
import { AcievementTeamComponent } from './components/pages/acievement-team/acievement-team.component';
import { NewIdComponent } from './components/pages/new-id/new-id.component';
const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'under-construction', component: UnderConstructionComponent },
  //{ path: 'photo', component: PhotoComponent },
  { path: 'notice', component: NoticeComponent },
  { path: 'detail/:id/:category', component: DetailsComponent },
  { path: 'at-a-glance', component: TemplatePageComponent },
  { path: 'infrastructure', component: TemplatePageComponent },
  { path: 'history', component: TemplatePageComponent },
  { path: 'mission-and-vision', component: TemplatePageComponent },
  { path: 'motto-&-logo-description', component: TemplatePageComponent },
  { path: 'infustructure', component: TemplatePageComponent },
 // { path: 'news-and-events', component: NewsComponent },
  {
    path: "news-and-events",
    children: [
      { path: "", component: NewsComponent },
      { path: ":ItemId", component: NewIdComponent },
    ],
  },
  { path: 'class-routine', component: TemplatePageComponent },
  { path: 'exam-routine', component: TemplatePageComponent },
  { path: 'syllabus', component: TemplatePageComponent },
  { path: 'lesson-plan', component: TemplatePageComponent },
  { path: 'calander-&-year-planner', component: TemplatePageComponent },
  { path: 'house-activities', component: TemplatePageComponent },
  { path: 'admission-circular', component: TemplatePageComponent },
  { path: 'admission-prospectus', component: TemplatePageComponent },
  { path: 'admission-form', component: TemplatePageComponent },
  { path: 'selected-candidates', component: TemplatePageComponent },
  { path: 'waiting-list', component: TemplatePageComponent },
  { path: 'payment-process', component: TemplatePageComponent },
  // { path: 'administration/governing-body', component: TemplatePageComponent },
  // { path: 'administration/message-of-chairman', component: TemplatePageComponent },
  // { path: 'administration/message-of-principal', component: TemplatePageComponent },
  // { path: 'administration/teachers-list-school', component: TemplatePageComponent },
  // { path: 'administration/teachers-list-college', component: TemplatePageComponent },
  // { path: 'administration/staff-information', component: TemplatePageComponent },
  { path: "message-of-principal", component: PrincipalComponent },
  { path: "teacher-information", component: TeachersComponent }, //Dynamic
  { path: "staff-information", component: EmployesComponent }, //Dynamic,
  { path: "message-of-chairman", component: ChairmanComponent }, //Dynamic
  { path: "administration/ex-principals", component: TemplatePageComponent },
  {
    path: "administration",
    children: [
      { path: "", component: AdministrationComponent },
      { path: ":item", component: AdministrationComponent },
    ],
  },
  { path: 'employee-information', component: TemplatePageComponent },

  { path: 'ssc-results', component: TemplatePageComponent },
  { path: 'hsc-results', component: TemplatePageComponent },
  { path: 'recruitment', component: TemplatePageComponent },
  { path: 'debate-society-bangla', component: TemplatePageComponent },
  { path: 'extremporary-speech-society', component: TemplatePageComponent },
  { path: 'pronounciation-&-recitation-society-bangla', component: TemplatePageComponent },
  { path: 'present-speech-society', component: TemplatePageComponent },
  { path: 'essay-society', component: TemplatePageComponent },
  { path: 'science-fair-society', component: TemplatePageComponent },
  { path: 'biology-society', component: TemplatePageComponent },
  { path: 'robotics-and-engineering', component: TemplatePageComponent },
  { path: 'chemistry-society', component: TemplatePageComponent },
  { path: 'math-society', component: TemplatePageComponent },
  { path: 'computer-society', component: TemplatePageComponent },
  { path: 'football', component: TemplatePageComponent },
  { path: 'cricket', component: TemplatePageComponent },
  { path: 'volleyball', component: TemplatePageComponent },
  { path: 'basketball', component: TemplatePageComponent },
  { path: 'handball', component: TemplatePageComponent },
  { path: 'chess-club', component: TemplatePageComponent },
  { path: 'batminton', component: TemplatePageComponent },
  { path: 'table-tennis', component: TemplatePageComponent },
  { path: 'bncc', component: TemplatePageComponent },
  { path: 'boys-scout', component: TemplatePageComponent },
  { path: 'rover-scout', component: TemplatePageComponent },
  { path: 'girls-in-scouting', component: TemplatePageComponent },
  { path: 'band-society', component: TemplatePageComponent },
  { path: 'general-knowledge-society', component: TemplatePageComponent },
  { path: 'drawing-society', component: TemplatePageComponent },
  { path: 'music-society', component: TemplatePageComponent },
  { path: 'dance-society', component: TemplatePageComponent },
  { path: 'acting-society', component: TemplatePageComponent },
  { path: 'islam-teaching-society', component: TemplatePageComponent },
  { path: 'health-society', component: TemplatePageComponent },
  { path: 'magazine', component: TemplatePageComponent },
  { path: 'nursery', component: TemplatePageComponent },
  { path: 'kg', component: TemplatePageComponent },
  { path: 'one', component: TemplatePageComponent },
  { path: 'two', component: TemplatePageComponent },
  { path: 'three', component: TemplatePageComponent },
  { path: 'four', component: TemplatePageComponent },
  { path: 'five', component: TemplatePageComponent },
  { path: 'six', component: TemplatePageComponent },
  { path: 'seven', component: TemplatePageComponent },
  { path: 'eight', component: TemplatePageComponent },
  { path: 'nine', component: TemplatePageComponent },
  { path: 'ten', component: TemplatePageComponent },
  { path: 'eleven', component: TemplatePageComponent },
  { path: 'twelve', component: TemplatePageComponent },
  { path: 'debate-society-english', component: TemplatePageComponent },
  { path: 'pronounciation-&-recitation-society-english', component: TemplatePageComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'notice', component: TemplatePageComponent },
   {
    path: "achievements",
    children: [
      { path: "", component: AchievementComponent },
      { path: ":ItemId", component: AcievementTeamComponent },
    ],
  },
  { path: 'jahangir', component: TemplatePageComponent },
  { path: 'ishakha', component: TemplatePageComponent },
  { path: 'zoynul', component: TemplatePageComponent },
  { path: 'nazrul', component: TemplatePageComponent },
  { path: 'why-study', component: TemplatePageComponent },
  { path: 'teachers-list-school', component: TemplatePageComponent },
  { path: 'teachers-list-college', component: TemplatePageComponent },
  { path: 'administration/message-of-chairman', component: TemplatePageComponent },
  { path: 'class-teacher', component: TemplatePageComponent },
  { path: 'academic-calendar', component: TemplatePageComponent },
  { path: 'prospectus', component: TemplatePageComponent },
  { path: 'admission-result', component: TemplatePageComponent },
  { path: 'classrooms', component: TemplatePageComponent },
  { path: 'computer-lab', component: TemplatePageComponent },
  { path: 'science-lab', component: TemplatePageComponent },
  { path: 'library', component: TemplatePageComponent },
  { path: 'canteen', component: TemplatePageComponent },
  { path: 'auditorium', component: TemplatePageComponent },
  { path: 'club', component: TemplatePageComponent },
  { path: 'students-login', component: TemplatePageComponent },
  { path: 'teachers-login', component: TemplatePageComponent },
  { path: 'school-information', component: TemplatePageComponent },
  { path: 'college-information', component: TemplatePageComponent },
  { path: 'scout', component: TemplatePageComponent },
  { path: 'cultural-program', component: TemplatePageComponent },
  { path: 'science-fair', component: TemplatePageComponent },
  { path: 'sports', component: TemplatePageComponent },
  { path: 'debate-competition', component: TemplatePageComponent },
  { path: 'business-club', component: TemplatePageComponent },
  { path: 'it-club', component: TemplatePageComponent },
  { path: 'exam-notice', component: TemplatePageComponent },
  { path: 'payment-manual', component: TemplatePageComponent },
  { path: 'admission-notice', component: TemplatePageComponent },
  { path: 'course-and-program', component: TemplatePageComponent },
  { path: 'payment-procedure', component: TemplatePageComponent },
  { path: 'modern-lab', component: TemplatePageComponent },
  { path: 'smart-classroom', component: TemplatePageComponent },
  { path: 'enrich-library', component: TemplatePageComponent },
 // { path: 'school-teacher', component: TemplatePageComponent },
 // { path: 'application',  component: SchoolTeacherComponent },
  { path: 'ac-classroom', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },
  { path: '', component: TemplatePageComponent },

  {
    path: "college-teacher",
    component: CollegeTeacherComponent,
  },
  { path: "photo-gallery", component: ImageGalleryComponent }, //Dynamic
  { path: "video-gallery", component: VideoGalleryComponent }, //Dynamic
  {
    path: "imageFolder",
    children: [
      { path: "", component: ImageFolderComponent },
      { path: ":folderId", component: ImageFolderComponent },
    ],
  },
  {
    path: "videoFolder",
    children: [
      { path: "", component: VideoFolderComponent },
      { path: ":folderId", component: VideoFolderComponent },
    ],
  },

  {
    path: "school-teacher",
    component: SchoolTeacherComponent,
  },



  { path: ':dynamicRoute', component: TemplatePageComponent },
  { path: ':dynamicRoute/:dynamicSubRoute', component: TemplatePageComponent },
  { path: '**', component: HomeComponent }, // This line will remain down from the whole pages component list
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }